import moment from "moment";
import * as _ from "underscore";
import {
  isCompleted,
  isScheduled,
  isStudentCanceled,
  isStudentMissed,
} from "./sessionStatus";

export function getNumberOfCompletedSessions(member) {
  let completedSessions = _.filter(member.sessions, function (s) {
    return isCompleted(s.status);
  });

  return completedSessions.length;
}

export function getNumberOfSkippedSessions(member) {
  let missedSessions = _.filter(member.sessions, function (s) {
    return isStudentMissed(s.status) || isStudentCanceled(s.status);
  });

  return missedSessions.length;
}

export function getProgressBarSessions(member) {
  let sessions = _.filter(member.sessions, function (s) {
    return (
      isCompleted(s.status) ||
      isStudentMissed(s.status) ||
      isStudentCanceled(s.status) ||
      isScheduled(s.status)
    );
  });
  return sessions;
}

export function getLastSession(member) {
  let lastSession = null;
  _.each(member.sessions, function (s) {
    if (isCompleted(s.status)) {
      if (!lastSession || moment(s.scheduled).isAfter(lastSession.scheduled)) {
        lastSession = s;
      }
    }
  });
  return lastSession;
}

export function getTargetDate(plan, startDate) {
  // Returns predicted target date, calculated from duration and frequency.
  const duration = plan.duration;
  const weeklyFrequency = plan.weekly_frequency;
  const numberOfWeeks = Math.ceil(duration / weeklyFrequency);
  return moment(startDate).add(numberOfWeeks, "weeks").toISOString();
}

export function getFrequencyString(weeklyFrequency) {
  if (!weeklyFrequency) {
    return "";
  }
  weeklyFrequency = parseInt(weeklyFrequency, 10);
  if (weeklyFrequency < 1) {
    return "";
  }
  if (weeklyFrequency === 1) {
    return "Once a week";
  } else if (weeklyFrequency === 2) {
    return "Twice a week";
  } else {
    return weeklyFrequency + " times a week";
  }
}

export function transformPlan(plan) {
  plan.from = plan.start_date;
  plan.number_of_sessions = parseInt(plan.duration, 10);
  plan.sessions = plan.sessions
    ? _.sortBy(plan.sessions, s => moment(s.scheduled).toDate().getTime())
    : [];
  const lastSession =
    plan.sessions && plan.sessions[plan.duration - 1]
      ? plan.sessions[plan.duration - 1]
      : null;
  plan.to = lastSession ? lastSession.scheduled : getTargetDate(plan, plan.from);
  plan.frequencyString = getFrequencyString(plan.weekly_frequency);

  return plan;
}
